




























import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {CourseItemData, CourseItemStyle, CourseTheme} from './course-item';

@Component
export default class CourseItem extends Vue {
  @Prop()
  private data?: CourseItemData & { day_end: number };

  @Prop()
  private width: number | undefined;

  @Prop()
  private index: number | undefined;

  @Emit('courseClick')
  private courseClick(event: MouseEvent): Promise<CourseItemData> {
    // @ts-ignore
    let courseDom = event.path.find((dom: HTMLElement) => {
      if (dom.className == `course`) {
        return dom;
      }
    });
    return Promise.resolve(Object.assign(JSON.parse(JSON.stringify(this.data)), {ref: courseDom}));
  }

  /**课程*/
  public courseColor(theme: CourseTheme): CourseItemStyle {
    return {
      header: {backgroundColor: theme.header},
      content: {backgroundColor: theme.content},
      name: {color: theme.name},
      store: {color: '#000'}
    };
  }

  /**普通内容梳理*/
  get courseContent(): Map<string, { store: Array<string>, theme: CourseItemStyle }> {
    let data: CourseItemData = JSON.parse(JSON.stringify(this.data));
    let map: Map<string, { store: Array<string>, theme: CourseItemStyle }> = new Map<string, { store: Array<string>, theme: CourseItemStyle }>();

    data?.course!.forEach((value) => {
      if (!value.show) {
        return;
      }
      if (map.has(value.name)) {   //判断是否存在该课程
        let stores = map.get(value.name);
        stores!.store.push(value.store);
        map.set(value.name, stores!);
      } else {
        map.set(value.name, {theme: this.courseColor(value.theme!), store: new Array<string>(value.store)});
      }
    });
    return map;
  }

  /**集训内容梳理*/
  get courseTraining() {
    let data: CourseItemData & { day_end: number } = JSON.parse(JSON.stringify(this.data));
    let course: { theme: CourseItemStyle; name: string; teacher: string; };
    if (data?.course) {
      let value = data?.course[0];
      course = {theme: this.courseColor(value.theme!), name: value.name, teacher: value.teacher!};
    }
    return course!;
  }

  /**集训课程样式*/
  get courseTrainingStyle() {
    return {
      width: `${this.width! * 141.94}px`
    };
  }

  /**是否显示该课程*/
  get courseShow() {
    return this.data?.course?.some(course => course.show);
  }

  /**是否剧目*/
  get courseType() {
    return this.data?.day_end == 1;
  }


  /**获取主题样式*/
  get courseThemeParse(): CourseItemStyle {
    return this.courseColor(this.data?.theme!);
  }
}
